import { TeachingLoadReportType, TimetableReportType } from '@bp/planung-graphql-types';
import dayjs from 'dayjs';
import { TimetableReportsTableType } from '../components/EvaluateTimetable/TimetableReportsTable';
import { ReportType } from '../components/EvaluateTimetable/types';
import { apiHelper } from './apiHelper';
import { showSuccessCreateToast, showSuccessDeleteToast, showUserDbErrorToast } from './toast';

export const downloadReport = async (
  report: TimetableReportsTableType,
  reportType: TeachingLoadReportType | TimetableReportType,
) => {
  const downloadFileName = report.name.replace(/ /g, '_') + '_' + report.timestamp.format('YYYY-MM-DD');

  return await apiHelper<void>({
    method: 'GET',
    path: `/pdf/${reportType}/${report.uuid}`,
    type: 'download',
    downloadFileName,
  });
};

export const deleteReport = async (
  report: { uuid: string; name: string },
  reportType: TeachingLoadReportType | TimetableReportType,
) => {
  const response = await apiHelper<{ message: string }>({
    method: 'DELETE',
    path: `/pdf/${reportType}/${report.uuid}`,
  });

  if (response) {
    showSuccessDeleteToast();
  } else {
    showUserDbErrorToast();
  }

  return response;
};

export const downloadDebug = async (uuid: string, type: ReportType) => {
  return await apiHelper<void>({
    method: 'GET',
    path: `/pdf/export/${type}/${uuid}`,
    type: 'download',
    downloadFileName: type + '_' + uuid + '_' + dayjs().format('YYYY-MM-DD') + '.json',
  });
};

export const createTimetableCollectiveReport = async (
  uuid: string,
  type: ReportType,
  subType: TimetableReportType | undefined,
) => {
  const response = await apiHelper<{ uuid: string }>({
    method: 'POST',
    path: `/pdf/${type}/${subType}/${uuid}`,
    type: 'json',
  });

  if (response) {
    showSuccessCreateToast();
  } else {
    showUserDbErrorToast();
  }

  return response;
};

export const createTimetableSingleReport = async (
  uuid: string,
  type: ReportType,
  subType: TimetableReportType | undefined,
) => {
  const response = await apiHelper<{ uuid: string }>({
    method: 'POST',
    path: `/pdf/timetablezip/${subType}/${uuid}`,
  });

  if (response) {
    showSuccessCreateToast();
  } else {
    showUserDbErrorToast();
  }

  return response;
};

export const createTeachingLoadReport = async (
  uuid: string,
  scenario: string,
  type: ReportType,
  subType: TimetableReportType | TeachingLoadReportType | undefined,
) => {
  const response = await apiHelper<Response>({
    method: 'POST',
    path: `/pdf/${type}/${subType}/${uuid}/${scenario}`,
  });

  if (response) {
    showSuccessCreateToast();
  } else {
    showUserDbErrorToast();
  }

  return response;
};
